var _path, _g, _g2, _g3, _g4, _path2, _path3, _g5, _g6, _g7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 497,
    viewBox: "0 0 422 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_24",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 511,
    height: 497
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481 14C376.937 238.829 240.048 269.493 169.571 231.664C90.0898 189.002 187.459 72.2019 265.551 212.358C318.355 307.13 229.923 390.273 103.631 324.253C128.317 342.396 143.997 388.558 133.865 417.707C116.294 468.252 53.3173 472.705 17 451.471",
    stroke: "black",
    strokeWidth: 65.5903
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_24)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-110.752 476.654C90.4703 469.726 85.7021 702.062 58.1652 819.092C75.7905 843.629 107.826 898.148 94.9636 919.97C78.8861 947.242 12.0232 1025.55 -102.111 1098.28C-216.244 1171.02 -292.681 1000.55 -440.886 747.169C-589.088 493.784 -362.28 485.315 -110.752 476.654Z",
    fill: "#C03AEC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.949 195.313C329.171 188.384 324.403 420.72 296.866 537.753C314.491 562.287 346.527 616.809 333.664 638.628C317.587 665.902 250.724 744.211 136.59 816.947C22.4568 889.68 -53.9809 719.214 -202.185 465.828C-350.389 212.442 -123.579 203.973 127.949 195.313Z",
    fill: "#6369F7",
    fillOpacity: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.552 490.251C277.948 485.417 274.621 647.521 255.408 729.178C267.705 746.295 290.057 784.335 281.083 799.559C269.865 818.587 223.214 873.223 143.581 923.977C63.9482 974.724 10.6169 855.783 -92.7876 678.994C-196.192 502.203 -37.9431 496.294 137.552 490.251Z",
    fill: "#36CF5D"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.658 730.589C483.961 886.184 341.366 786.913 279.28 717.831C257.196 721.11 210.88 722.981 202.302 704.235C191.578 680.802 168.813 597.809 167.838 481.228C166.863 364.648 302.473 376.805 517.456 368.623C732.438 360.44 649.779 536.094 557.658 730.589Z",
    fill: "#FD2E1B"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1_24)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M531.731 527.747C373.856 570.699 311.377 369.208 299.872 263.092C278.873 245.147 237.873 203.954 241.867 182.751C246.86 156.247 277.641 76.3443 347.563 -7.42971C417.484 -91.2036 526.828 41.946 716.832 233.508C906.835 425.071 729.074 474.056 531.731 527.747Z",
    fill: "#FF8D32"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_24",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -266,
    y: 287,
    width: 1327,
    height: 354
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.37 293.418C1017.77 347.093 983.801 489.881 816.808 420.991C597.391 330.477 518.466 411.153 518.466 523.968C460.501 444.604 359.634 449.091 301.014 459.362C123.187 490.517 -40.8847 602.021 -264.559 607.268",
    stroke: "black",
    strokeWidth: 65.5903,
    strokeLinejoin: "bevel"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_24)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1_24)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.28 233.285C536.694 169.682 589.97 240.478 609.056 283.827C620.272 285.758 642.997 292.233 644.172 302.678C645.642 315.734 643.477 359.551 625.423 416.161C607.369 472.771 543.631 445.272 438.226 414.974C332.821 384.676 400.762 312.788 476.28 233.285Z",
    fill: "#FD2E1B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.603 335.642C539.878 340.002 538.114 447.531 526.823 500.75C534.139 512.788 547.447 539.269 542.143 548.9C535.514 560.939 507.911 594.726 460.738 624.15C413.566 653.575 381.776 571.672 320.209 448.628C258.642 325.584 352.507 330.192 456.603 335.642Z",
    fill: "#FF8D32"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter8_f_1_24)"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter9_f_1_24)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.178 813.7C218.227 816.763 153.852 678.813 131.408 609.454C117.41 594.792 89.1335 562.246 88.019 549.355C86.6258 533.242 90.8481 487.086 115.437 444.486C140.025 401.887 219.009 503.521 350.15 654.771C481.291 806.026 393.617 809.869 296.178 813.7Z",
    fill: "#FFE712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.884 609.3L131.849 609.191L131.77 609.108C124.779 601.787 114.222 589.998 105.278 578.434C100.805 572.652 96.7418 566.935 93.7301 561.867C90.7057 556.777 88.7852 552.412 88.5172 549.312C87.1321 533.293 91.3365 487.24 115.87 444.736C118.889 439.505 122.706 436.544 127.306 435.577C131.928 434.605 137.427 435.629 143.834 438.557C156.657 444.417 172.878 457.796 192.484 477.29C222.247 506.884 259.688 550.447 304.703 602.821C318.967 619.417 333.991 636.897 349.773 655.099C382.548 692.901 401.612 721.45 410.28 743.062C418.945 764.664 417.183 779.218 408.504 789.191C399.776 799.222 383.938 804.768 364.079 808.028C344.243 811.285 320.527 812.242 296.159 813.2C276.828 813.96 258.302 805.98 241.012 792.439C223.721 778.897 207.699 759.82 193.394 738.457C164.783 695.731 143.096 643.949 131.884 609.3Z",
    stroke: "black"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9552 583.945C-62.2816 587.275 -142.584 437.325 -170.581 361.932C-188.043 345.996 -223.315 310.618 -224.705 296.606C-226.443 279.092 -221.176 228.92 -190.504 182.615C-159.832 136.31 -61.3069 246.785 102.281 411.192C265.868 575.604 156.501 579.782 34.9552 583.945Z",
    fill: "white",
    fillOpacity: 0.9
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_24",
    x: -619.158,
    y: 345.322,
    width: 848.271,
    height: 901.039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5903,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_24",
    x: -380.458,
    y: 63.9805,
    width: 848.272,
    height: 901.041,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5903,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1_24",
    x: -256.826,
    y: 358.965,
    width: 671.16,
    height: 707.98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5903,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1_24",
    x: 36.6521,
    y: 237.167,
    width: 747.788,
    height: 707.263,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5903,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1_24",
    x: -30.2627,
    y: -164.157,
    width: 969.737,
    height: 908.181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5903,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1_24",
    x: 405.399,
    y: 125.426,
    width: 533.339,
    height: 597.028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5903,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1_24",
    x: 252.842,
    y: 76.727,
    width: 522.887,
    height: 503.458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5903,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1_24",
    x: 169.416,
    y: 202.307,
    width: 505.125,
    height: 559.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5903,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1_24",
    x: 418.082,
    y: 94.2322,
    width: 388.177,
    height: 481.977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5903,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1_24",
    x: -43.3979,
    y: 303.54,
    width: 591.042,
    height: 641.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5903,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_1_24",
    x: 83.7827,
    y: 434.721,
    width: 336.68,
    height: 387.029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_24"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_24",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_1_24",
    x: -325,
    y: 72,
    width: 610,
    height: 612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 707.376,
    height: 325.984,
    fill: "white",
    transform: "translate(100.918 286.859)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.839ea45ce25d21e594634f997a3bb141.svg";
export { ForwardRef as ReactComponent };